<template lang="pug">
v-dialog(
  :value="value"
  @input="$emit('input', $event)"
  content-class="sysgrao-dialog-content"
  max-width="1200px"
  width="1200px"
)
  v-card.panel-dialog
    .panel-card__header.panel-card__header--dialog
      span.panel-card__title {{ dialogTitle }}
      v-btn(icon, @click="$emit('input', false)")
        v-icon mdi-close

    v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll.producer-bases-dialog__content
      .producer-bases-dialog__summary
        .producer-bases-dialog__summary-card(
          v-for="card in summaryCards"
          :key="card.key"
        )
          .producer-bases-dialog__summary-label {{ card.label }}
          .producer-bases-dialog__summary-value {{ card.value }}

      v-data-table.producer-bases-dialog__table(
        :headers="tableHeaders"
        :items="baseRows"
        hide-default-footer
        no-data-text="Nenhum dado encontrado para o período selecionado."
        mobile-breakpoint="0"
      )
        template(v-slot:item.nome="{ item }")
          span.producer-bases-dialog__base-name {{ item.nome }}
        template(v-slot:item.romaneios="{ item }")
          span.producer-bases-dialog__number {{ formatInteger(item.romaneios) }}
        template(v-slot:item.toneladas="{ item }")
          span.producer-bases-dialog__number {{ formatDecimal(item.toneladas) }}
        template(v-slot:item.representatividadeTon="{ item }")
          span.producer-bases-dialog__number {{ formatPercent(item.representatividadeTon) }}
</template>

<script>
const NUMBER_FORMATTERS = {
  integer: new Intl.NumberFormat("pt-BR"),
  decimal: new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 }),
  percent: new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 1, maximumFractionDigits: 1 })
};

const TABLE_HEADERS = [
  { text: "Clientes (Bases de dados)", value: "nome", sortable: false },
  { text: "Romaneios", value: "romaneios", align: "center", sortable: false, width: "130px" },
  { text: "Toneladas", value: "toneladas", align: "end", sortable: false, width: "140px" },
  {
    text: "Representatividade (Ton)",
    value: "representatividadeTon",
    align: "end",
    sortable: false,
    width: "220px"
  }
];

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function toNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export default {
  name: "ProdutorBasesDialog",

  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null }
  },

  computed: {
    dialogTitle() {
      return this.item?.produtor || "Detalhes do produtor";
    },

    summaryCards() {
      return [
        { key: "clientes", label: "Clientes", value: this.formatInteger(this.baseRows.length) },
        { key: "romaneios", label: "Romaneios", value: this.formatInteger(this.item?.romaneios) },
        { key: "toneladas", label: "Toneladas", value: this.formatDecimal(this.item?.toneladas) }
      ];
    },

    baseRows() {
      return toArray(this.item?.bases).map((base, index) => ({
        key: base?.hash,
        nome: base?.nome || "Não informado",
        romaneios: toNumber(base?.romaneios),
        toneladas: toNumber(base?.toneladas),
        representatividadeTon: toNumber(base?.representatividadeTon),
        representatividadeRom: toNumber(base?.representatividadeRom)
      }));
    },

    tableHeaders() {
      return TABLE_HEADERS;
    }
  },

  methods: {
    formatInteger(value) {
      return NUMBER_FORMATTERS.integer.format(Math.round(toNumber(value)));
    },

    formatDecimal(value) {
      return NUMBER_FORMATTERS.decimal.format(toNumber(value));
    },

    formatPercent(value) {
      return `${NUMBER_FORMATTERS.percent.format(toNumber(value))}%`;
    }
  }
};
</script>

<style scoped>
.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__header--dialog {
  background: #edf2f7;
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__title {
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-card__dialog-content--scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

.producer-bases-dialog__content {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px !important;
  border-bottom: 1px solid #d5deea;
}

::v-deep .sysgrao-dialog-content .v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}

.producer-bases-dialog__summary {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.producer-bases-dialog__summary-card {
  background: #eef3f8;
  border: 1px solid #d5deea;
  border-radius: 8px;
  min-height: 54px;
  padding: 9px 12px 10px;
}

.producer-bases-dialog__summary-label {
  color: #6b7f99;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
  text-transform: uppercase;
}

.producer-bases-dialog__summary-value {
  color: #243a59;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 3px;
}

.producer-bases-dialog__table {
  background: #ffffff;
  border: 1px solid #d5deea;
  border-radius: 8px;
  overflow: hidden;
}

.producer-bases-dialog__table ::v-deep table thead {
  background-color: #edf2f7;
}

.producer-bases-dialog__table ::v-deep table thead th {
  color: #6b7889 !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.producer-bases-dialog__table ::v-deep table thead th span {
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  letter-spacing: 0.01em;
}

.producer-bases-dialog__table ::v-deep tbody td {
  color: #253f66;
  font-size: 13px;
}

.producer-bases-dialog__table ::v-deep tbody tr:nth-child(odd) {
  background-color: #fafbfd;
}

.producer-bases-dialog__base-name {
  color: #425a78;
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.45;
  padding-right: 16px;
}

.producer-bases-dialog__number {
  color: #173256;
  font-weight: 700;
}

@media (max-width: 959px) {
  .panel-card__header--dialog {
    padding: 16px;
  }

  .producer-bases-dialog__content {
    gap: 16px;
  }

  .producer-bases-dialog__summary {
    grid-template-columns: 1fr;
  }
}
</style>
